import { Options } from "@material-ui/core";
import { Maybe } from "graphql/jsutils/Maybe";
import { useTranslation } from "react-i18next";
import { FlexControlProps } from "../models/flexible/flex-field-controller";
import { GeneralTreatingPhysicianFieldController } from "./general-treating-physician-field-controller";
import { getEnumValues } from "../utils/get-enum-values";
import { TreatingPhysicianTitle } from "../models/generated/graphql";

export class TreatingPhysicianTitleFieldController extends GeneralTreatingPhysicianFieldController {
	override useControlProps(): Maybe<FlexControlProps> | undefined {
		const { t } = useTranslation();

		return {
			controlType: "combo",
			options: getEnumValues(TreatingPhysicianTitle).map((v) => ({
				label: t(`physician-title-${v}`),
				value: v,
			})) as Options[],
		};
	}
}
